<template>
	<!-- 常德概况 -->
	<div class="container">
		<myHeader></myHeader>
		<div class="main">
			<div class="banner">
				<img src="../assets/banner/overview_banner.jpg" />
			</div>
			<div class="over-view-content" v-html="articleData.articleContent">

			</div>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import {
		ref,
		defineComponent
	} from 'vue'
	import {
		ElMessage
	} from 'element-plus'
	import { getArticleDetail } from '@/axios/api'
	import myHeader from '@/components/layouts/myHeader'
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	export default defineComponent({
		components: {
			myHeader,
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {
			const articleData = ref('');
			
			(function getData() {
				getArticleDetail('/cdMapApi/api/article/detail/' + 107, {
					
				}).then(function (res){
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						// 当前渲染数据列表
						articleData.value = data
						
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				})
			})();
			
			return {
				articleData
			}
		}
	})
</script>

<style lang="scss">
	.container {
		height: auto;
		min-height: 100vh;
		margin: 0;
		padding: 0;

		.main {

			.banner {
				width: 100%;

				img {
					width: 100%;
				}
			}

			.over-view-content {
				padding: 15px 20px;
				
				p {
					
					img {
						width: 100%!important;
						margin: 10px 0px!important;
					}
				}
			}
		}
	}
</style>